// Import react
import React, { useState, useEffect } from "react";

// Import supabase configuration
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { topFiveProfiles } from "../redux/actions/actions";

// Import custom components
import ProfileCard from "../components/profile/profile";
import Header from "../components/header/boardHeader";
import Search from "../components/search/search";
import Skeleton from "react-loading-skeleton";
import { Oval } from "react-loader-spinner";
import { hotjar } from 'react-hotjar';

export default function SearchPage() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [profiles, setProfiles] = useState([]);
  const [showSearch, setShowSearch] = useState(false);
  const { data } = useSelector((state) => state.profile);
  const [showLoader, setShowLoader] = useState(false);
  const [showSkeleton, setShowSkeleton] = useState(true);

  useEffect(() => {  
    getTopProfiles(); 
  }, []);

  const clearLocalStorage = () => {
    localStorage.removeItem("searchedObject");
    localStorage.removeItem("searchedItem");
    localStorage.removeItem("inputField");
    localStorage.removeItem("skillsWithLevel");
  };

  const [showExitPrompt, setShowExitPrompt] = useState(false);

  window.onload = function () {
    clearLocalStorage();
  };

  useEffect(() => {
    document.title = "Gaper";
    clearLocalStorage();
    setShowSearch(true);

    // Init horjar
    // testing token
		// hotjar.initialize(2875931, 6);
    // liveToken
		hotjar.initialize(2908411, 6);
  }, [showExitPrompt]);

  useEffect(() => {
    setProfiles(data);
  }, [data]);

  const getTopProfiles = () => {
    dispatch(topFiveProfiles())
      .then(() => {
        setShowSkeleton(false);
        // setProfiles(data);
        // navigate("/search");
      })
      .catch(() => {
        console.log("Error");
      });
  };

  const changeState = (value) => {
    navigate(value);
  };

  const changeLoader = (check) => {
    check == "start" ? setShowLoader(true) : setShowLoader(false);
  };
  let skeletonRepeated = 5

  return (
    <div className="w-full min-h-screen h-auto">
      {/* Header component */}
      <div className="sticky top-0 z-50">
        <Header current="home" />
      </div>

      {/* show Loader on condition*/}
      {showLoader && (
        <div className="fixed flex items-center justify-center z-10 w-full h-full top-0 bg-white-1">
          {/* Add backdrop */}
          
          <div className={`relative flex`}>
            <Oval
                color="white"
                secondaryColor="grey"
                height="40"
                width="60"
              />
              <div className="flex items-center">Hold Tight-just getting this page ready.</div>
          </div>
        </div>
      )} 

      {/* Show profiles */}
      <div className="p-10 sm:px-20 grid-cols-12 bg-white-2 ">
        {/* Search component */}
        {showSearch && (
          <Search
            multi={true}
            isNavigate={true}
            changeState={changeState}
            showLoader={changeLoader}
          />
        )}

        {/* Profiles */}
        <div className="py-10">
          {
            <div>
              <div className="text-3xl font-bold mb-3">Profiles</div>

              {showSkeleton ? (
                [...Array(skeletonRepeated)].map((e , index) => (
                <div className="rounded-2xl bg-white-1 shadow-clientCard h-60 grid grid-cols-12 gap-3 p-6 box-border mb-10" key={index}>
                  <div className="col-span-12 sm:col-span-3 lg:col-span-2 flex mt-5 relative z-0">
                  <Skeleton height={90} width={90} />
                  </div>
                  <div  className="col-span-12 sm:col-span-9 lg:col-span-10 grid grid-cols-12 gap-3 z-0">
                    {/*For name and email */}
                    <div className="col-span-12">
                      <div>
                        <Skeleton height={25} width={150} />
                      </div>
                      <div>
                        <Skeleton height={20} width={190} />
                      </div>
                    </div>
                    {/* For Location and experience */}
                    <div className="col-span-12 lg:col-span-5 z-0">
                      {/* Location */}
                      <div className=" flex items-center">
                        <Skeleton height={18} width={92} className="mr-1" />
                      </div>
                      {/* experience */}
                      <div className="flex items-center">
                        <Skeleton height={25} width={92} className="mr-1" />
                      </div>
                    </div>
                    {/* For timezone and hourly rate */}
                    <div className="col-span-12 lg:col-span-4 z-0">
                      {/* Timezone */}
                      <div className="flex items-center">
                        <Skeleton height={18} width={92} className="mr-1" />
                      </div>
                      {/* hourly rate */}
                      <div className="flex items-center">
                        <Skeleton height={25} width={92} className="mr-1" />
                      </div>
                    </div>
                    <div className="hidden md:block col-span-3 z-0">
                      <div className="-ml-6">
                      <Skeleton height={43} width={250} />
                      </div>
                    </div>
                    <div className="hidden md:block col-span-2 z-0"></div>
                    <div className="col-span-12 md:col-span-10 flex flex-wrap z-0">
                      <div className="p-1 mr-2 mb-2 rounded-sm">
                        <Skeleton height={38} width={400} />
                      </div>
                    </div>
                  </div>
                </div>
                ))
              ):(
                <>
                {/* Render profiles here */} 
               {profiles.map((profile, index) => (
                <ProfileCard
                  key={index}
                  id={index}
                  data={profile}
                  searched={false}
                  showLoader={showLoader}
                />
              ))}
                </>
              )}               
            </div>
          }
        </div>
      </div>
    </div>
  );
}
